import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-14 h-[10vh] flex flex-row justify-between items-center border-blue-100 border-b-2 py-2 px-4" }
const _hoisted_2 = { class: "text-black flex items-center" }
const _hoisted_3 = { class: "font-semibold max-sm:text-xl text-xl" }
const _hoisted_4 = { class: "flex flex-row gap-4 items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Ativar"),
  /*#__PURE__*/_createElementVNode("span", { class: "max-md:hidden" }, " seu plano")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-envelope text-2xl text-gray-500 opacity-70 sm:text-xl" }, null, -1)

import { Button } from '@/components/ui/button';

import { computed } from 'vue';
import HeaderAvatarMenu from '@/components/HeaderAvatarMenu.vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { CLEAR_AUTH } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderComponent',
  props: {
  title: String,
},
  setup(__props) {



const getBaseRoute = computed(() => {
  let routePath = route.fullPath.split('/').slice(1);
  let baseRoute = [];
  while (baseRoute.length < 2 && routePath.length >= 0) {
    baseRoute.push(routePath.at(0));
    routePath = routePath.slice(1);
  }
  return `/${baseRoute.join('/')}`;
});

const { commit } = useStore();
const router = useRouter();
const route = useRoute();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: getBaseRoute.value }, {
        default: _withCtx(() => [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(__props.title), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default"),
      _createVNode(_unref(Button), {
        variant: "outline",
        size: "sm",
        class: "flex items-center justify-center max-sm:text-sm font-semibold"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _hoisted_6,
      _createVNode(HeaderAvatarMenu, {
        onLOGOUT: _cache[0] || (_cache[0] = async () => {
        _unref(commit)(_unref(CLEAR_AUTH));
        await _unref(router).push('/login');
      })
      })
    ])
  ]))
}
}

})